import { createContext } from 'react';

const TownConfigContext = createContext(null);

export default TownConfigContext;
